module.exports = __webpack_public_path__ + "img/gc_country_flag_cn.8f842779.svg";